import { ScrollingText } from "@jesus-central-church/ui";
import { SbScrollingText } from "@storyblok/types/287435740670216/storyblok-components";

export function ScrollingTextComponent({ blok }: { blok: SbScrollingText }) {
  return (
    <ScrollingText
      text={blok.text as string}
      backgroundColor={blok.backgroundColor as string}
      textColor={blok.textColor as string}
    />
  );
}
